{#if $isUserLoggedIn}
  <TimelinePage timeline="favorites">
    {#if $pinnedPage !== '/favorites'}
      <DynamicPageBanner title="Favorites" icon="#fa-star"/>
    {/if}
  </TimelinePage>
{:else}
  <HiddenFromSSR>
    <FreeTextLayout>
      <h1>Favorites</h1>

      <p>Your favorites will appear here when logged in.</p>
    </FreeTextLayout>
  </HiddenFromSSR>
{/if}
<script>
  import TimelinePage from '../_components/TimelinePage.html'
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'
  import DynamicPageBanner from '../_components/DynamicPageBanner.html'

  export default {
    store: () => store,
    components: {
      TimelinePage,
      FreeTextLayout,
      HiddenFromSSR,
      DynamicPageBanner
    }
  }
</script>
